import * as ko from 'knockout';
import create from './create';
import dashboard from './dashboard';
import details from './details';

export default function () {
  ko.components.register(create.name, create);
  ko.components.register(dashboard.name, dashboard);
  ko.components.register(details.name, details);
}
